import Config from "@/config.js";

const IM_REMINDER = {
    KEY: "reminder",
};
const IM_PUSH = {
    KEY: "push",
};
const IM_TG = {
    KEY: "tg",
    BOT_NAME: process.env?.VUE_APP_IM_TG_BOT || "AMMHelperBot",
    AUTH_LINK: process.env?.VUE_APP_IM_TG_AUTH_LINK || "https://t.me/AMMHelperBot?start=auth_{{CLIENT_ID}}",
    MERGE_LINK: process.env?.VUE_APP_IM_TG_MERGE_LINK || "https://t.me/AMMHelperBot?start=merge_{{CLIENT_ID}}",
};
const IM_MAX = {
    KEY: "max",
    BOT_NAME: process.env?.VUE_APP_IM_MAX_BOT || "id781133769020_bot",
    AUTH_LINK: process.env?.VUE_APP_IM_MAX_AUTH_LINK || "https://max.ru/id781133769020_bot?start=auth_{{CLIENT_ID}}",
    MERGE_LINK: process.env?.VUE_APP_IM_MAX_MERGE_LINK || "https://max.ru/id781133769020_bot?start=merge_{{CLIENT_ID}}",
};
const IM_YANDEX = {
    KEY: "yandex",
    BOT_NAME: "",
    AUTH_LINK: "",
};
const IM_EMAIL = {
    KEY: "email",
    AUTH_LINK: process.env?.VUE_APP_IM_EMAIL_AITH_LINK || "https://1task.ru/_/auth/email/{{CLIENT_ID}}",
};

const IMs = {
    IM_REMINDER,
    IM_PUSH,
    IM_TG,
    IM_MAX,
    IM_YANDEX,
    IM_EMAIL,

    IMs: [
        {
            key: IM_PUSH.KEY,
            name: "Браузер",
            icon: require("@/assets/ims/web.png"),
            withNotifications: true,
        },
        {
            key: IM_TG.KEY,
            name: "Telegram",
            icon: require("@/assets/ims/tg.svg"),
            linkingHTML: "<p>Чтобы подключить Ваш аккаунт Telegram, проделайте следующее:</p>\n" +
                "<ol>\n" +
                "\t<li>1. Убедитесь, что у Вас зарегистрирован аккаунт в мессенджере Telegram</li>\n" +
                "\t<li>2. Пройдите по ссылке: <a href='{{LINK}}' target='_blank'>{{LINK}}</a></li>\n" +
                "\t<li>3. Следуйте инструкции в чате с ботом</li>\n" +
                "</ol>",
            authLink: IM_TG.AUTH_LINK,//"https://t.me/" + IM_TG.BOT_NAME + "?start=link_{{CLIENT_ID}}"
            mergeLink: IM_TG.MERGE_LINK,//"https://t.me/" + IM_TG.BOT_NAME + "?start=link_{{CLIENT_ID}}"
            withAuth: true,
            withNotifications: true,
            withGroups: true,
            isOptionalIM: true,
        },
        {
            key: IM_MAX.KEY,
            name: "Max",
            icon: require("@/assets/ims/max.svg"),
            linkingHTML: "<p>Чтобы подключить Ваш аккаунт Max, проделайте следующее:</p>\n" +
                "<ol>\n" +
                "\t<li>1. Убедитесь, что у Вас зарегистрирован аккаунт в мессенджере Max</li>\n" +
                "\t<li>2. Пройдите по ссылке: <a href='{{LINK}}' target='_blank'>{{LINK}}</a></li>\n" +
                "\t<li>3. Следуйте инструкции в чате с ботом</li>\n" +
                "</ol>",
            authLink: IM_MAX.AUTH_LINK,//"https://max.ru/" + IM_MAX.BOT_NAME + "?start=link_{{CLIENT_ID}}",
            mergeLink: IM_MAX.MERGE_LINK,
            withAuth: true,
            withNotifications: true,
            withGroups: true,
            isOptionalIM: true,
        },
        {
            name: "Email",
            key: IM_EMAIL.KEY,
            icon: require("@/assets/ims/at.svg"),
            withNotifications: true,
            withAuth: true,
            //authLink: IM_EMAIL.AUTH_LINK,
        },
        /*{
            key: IM_REMINDER.KEY,
            name: "Напоминание",
            icon: "mdi-bell-outline",
            iconColor: "orange",
            title: "Будет создано напоминание в виде задачи",
            withNotifications: true,
        },*/
        /*{
            key: "yandex",
            name: "Яндекс Мессенджер",
            icon: require("@/assets/ims/yandex.svg"),
            linkingHTML: "<p>Чтобы подключить Ваш аккаунт в Яндекс Мессендере, проделайте следующее:</p>\n" +
                "<ol>\n" +
                "\t<li>1. Убедитесь, что у Вас зарегистрирован аккаунт в Яндекс Мессендере</li>\n" +
                "\t<li>2. Пройдите по ссылке: <a href='{{LINK}}' target='_blank'>{{LINK}}</a></li>\n" +
                "\t<li>3. Следуйте инструкции в чате с ботом</li>\n" +
                "</ol>",
            authLink: null,
            withAuth: true,
            withNotifications: true,
        },*/
        /*{
            name: "SMS",
            key: "sms",
            icon: "/assets/ims/sms2.svg",
            isSoon: true,
            linkingHTML: "<p>Данный вид авторизации пока не доступен, но скоро появится!</p>"
        },*/
    ]
};

export default IMs;
